/*
  HILO - shared by hilo-explore.

  parseStyles turns the "Label:handle, Label:handle/tag" setting into a list.
  It lives out here for one reason: the split on a line break needs either an
  escape sequence or a regex, and an escape sequence inside a Liquid section
  has been mangled once already. A regex literal cannot be mangled the same
  way, and a file the theme editor does not reformat is a file that stays
  correct.
*/
window.hiloParseStyles = function (str) {
  if (!str) return [];
  var out = [];
  str.split(',').forEach(function (chunk) {
    chunk.split(/\r?\n/).forEach(function (p) {
      var i = p.indexOf(':');
      if (i < 1) return;
      var label = p.slice(0, i).trim();
      var t = p.slice(i + 1).trim();
      if (label && t) out.push({ label: label, t: t });
    });
  });
  return out;
};